import {combine, merge, sample} from 'effector';
import i18next from 'i18next';
import {toast} from 'react-toastify';

import {RestError, showRestError} from 'core/errors';
import {initFiltersTable, initSortingsTable} from 'core/hooks/grid2.0';
import {InnerFilters} from 'types';
import {StaffTableFilter} from 'types/profile';
import {mapSortings} from 'utils/grid-mappers';

import {
    data$,
    defaultFilters,
    defaultSortings,
    fetchDataFx,
    filters$,
    filtersChanged,
    filtersReset,
    Gate,
    pageNumber$,
    pageSize$,
    sortings$,
    sortingsChanged,
    sortingsReset,
    stateReset,
    tableStateChanged,
    deactivateStorageFx,
} from './index';

const mapStorageFilters = (filters: InnerFilters): StaffTableFilter[] =>
    Object.entries(filters)
        .filter(([, value]) => typeof value === 'string' && value.trim().length > 0)
        .map(([id, value]) => ({
            id,
            value: String(value).trim(),
        }));

data$.on(fetchDataFx.doneData, (_, data) => data).reset(Gate.close);
pageNumber$.reset(stateReset, Gate.close);
pageSize$.reset(stateReset, Gate.close);

initFiltersTable(filters$, filtersChanged, filtersReset, defaultFilters, stateReset);
initSortingsTable(sortings$, sortingsChanged, sortingsReset, defaultSortings, stateReset);

sample({
    clock: merge([Gate.open, tableStateChanged]),
    source: combine({
        filters: filters$,
        pageNumber: pageNumber$,
        pageSize: pageSize$,
        sortings: sortings$,
    }),
    fn: ({filters, pageNumber, pageSize, sortings}) => ({
        paging: {
            pageNumber,
            pageSize,
        },
        filters: mapStorageFilters(filters),
        sortings: mapSortings(sortings),
    }),
    target: fetchDataFx,
});

fetchDataFx.fail.watch(({error}) => showRestError(error as RestError));

deactivateStorageFx.fail.watch(({error}) => showRestError(error as RestError));
deactivateStorageFx.done.watch(() => {
    toast.success(i18next.t('pages.profile.storages.messages.deactivated'));
});
